import {
  AtLeastOneExitIntentRequiredRuleKey,
  AtLeastOneMessageRequiredRuleKey,
  AtLeastOneTriggerRequiredRuleKey,
  AtLeastOneMessageValidTriggerRequiredRuleKey,
  CampaignNameCharLimitRuleKey,
  CampaignNameRequiredRuleKey,
  DisplayWebContentTemplateRequiredRuleKey,
  FrequencyRequiredRuleKey,
  InactivityRequiredIfSelectedRuleKey,
  IpAddressOnlyRequiredForDisplayWebContentRuleKey,
  SendEmailRequiredConfigRuleKey,
  SendEmailRequiredWithSMBRuleKey,
  SendEmailTemplateRequiredRuleKey,
  SubjectLineRequiredRuleKey,
  WebContentNameRequiredRuleKey,
  SendEmailNameRequiredRuleKey,
  WebContentNameCharLimit,
  SendEmailNameCharLimit,
  EmbeddedSelectorRequiredRuleKey,
  EmbeddedPositionRequiredRuleKey,
  OnClickSelectorRequiredRuleKey,
} from '../domain/Workflow/Rules';
import { BranchNameCharLimit, NameRequiredRuleKey } from '../domain/Workflow/Rules/Branching/NameRequiredRule';
import { DomainRule } from '../domain/Workflow/types';
import { RulesToMessagesMapper } from './RulesToMessagesMapper';

const ruleKeysToFormElementDictionary: { [key: string]: string } = {
  // Display Website Content
  [DisplayWebContentTemplateRequiredRuleKey]: 'displayWebContent',
  [IpAddressOnlyRequiredForDisplayWebContentRuleKey]: 'displayWebContent',
  [WebContentNameRequiredRuleKey]: 'displayWebContent',
  [WebContentNameCharLimit]: 'WebContentNameCharLimit',
  [EmbeddedSelectorRequiredRuleKey]: 'displayWebContent',
  [EmbeddedPositionRequiredRuleKey]: 'displayWebContent',
  [SendEmailRequiredWithSMBRuleKey]: 'sendEmail',
  // Send Email
  [SendEmailRequiredConfigRuleKey]: 'sendEmail',
  [SendEmailNameRequiredRuleKey]: 'sendEmail',
  [SendEmailNameCharLimit]: 'sendEmail',
  [SendEmailTemplateRequiredRuleKey]: 'emailAllowList',
  [SubjectLineRequiredRuleKey]: 'emailAllowList',
  // Trigger
  [FrequencyRequiredRuleKey]: 'trigger',
  [AtLeastOneExitIntentRequiredRuleKey]: 'trigger',
  [AtLeastOneTriggerRequiredRuleKey]: 'trigger',
  [AtLeastOneMessageValidTriggerRequiredRuleKey]: 'trigger',
  [InactivityRequiredIfSelectedRuleKey]: 'trigger',
  [OnClickSelectorRequiredRuleKey]: 'trigger',
  // Branching
  [NameRequiredRuleKey]: undefined,
  [BranchNameCharLimit]: undefined,
  // Other
  [AtLeastOneMessageRequiredRuleKey]: undefined,
  [CampaignNameRequiredRuleKey]: undefined,
  [CampaignNameCharLimitRuleKey]: undefined,
};

export const failedRulesToStateValues = (
  rules: DomainRule[],
  mapper: RulesToMessagesMapper,
  keysDictionary = ruleKeysToFormElementDictionary,
) => {
  const failedRules = rules.filter(s => s.result === 'fail');

  const errors = failedRules.map(s => ({ [keysDictionary[s.ruleKey]]: true }));
  const validationResults = mapper.map(failedRules);

  return {
    errors,
    validationResults,
  };
};
